import { createActionGroup, props } from '@ngrx/store';

import { ProductSubcategories } from '../types';

export const ProductSubcategoriesActions = createActionGroup({
  source: '[Product Subcategories]',
  events: {
    loadProductSubcategories: props<{ productCatalog: string; categoryCode: string }>(),
    loadProductSubcategoriesSuccess: props<{ categories: ProductSubcategories }>(),
    setActiveSubcategories: props<{ activeIndex: number }>(),
    setVisibleItemsCount: props<{ visibleItemsCount: number }>(),
  },
});
